import { StatusCheckmarkIcon, StatusInProgressIcon } from '../../assets/icons';
import {
    StatusProgressContainer,
    StatusProgressList,
    StatusProgressStep,
    StatusProgressStepIcon,
    StatusProgressStepContent,
    StatusProgressStepTitle,
    StatusProgressStepDescription
} from './StatusProgressSteps.styles';

export const StatusProgressSteps = ({ file }) => {
    const relatedItemsCount = file?.relatedItems?.length || 0;
    
    const steps = [
        {
            id: 1,
            title: "1. Import file",
            description: "Successfully imported a personal balance sheet / spreadsheet tracker",
            status: "completed",
            icon: <StatusCheckmarkIcon />
        },
        {
            id: 2,
            title: "2. AI Convert Data",
            description: `The initial analysis identified ${relatedItemsCount} assets and liabilities`,
            status: "completed",
            icon: <StatusCheckmarkIcon />
        },
        {
            id: 3,
            title: "3. Deep Analysis",
            description: "To extract all financial information relevant to your portfolio, your files will go through deep analysis process. This can take up to 24h",
            status: "in-progress",
            icon: <StatusInProgressIcon />
        }
    ];

    return (
        <StatusProgressContainer>
            <StatusProgressList>
                {steps.map((step) => (
                    <StatusProgressStep key={step.id}>
                        <StatusProgressStepIcon>
                            {step.icon}
                        </StatusProgressStepIcon>
                        <StatusProgressStepContent>
                            <StatusProgressStepTitle>
                                {step.title}
                            </StatusProgressStepTitle>
                            <StatusProgressStepDescription>
                                {step.description}
                            </StatusProgressStepDescription>
                        </StatusProgressStepContent>
                    </StatusProgressStep>
                ))}
            </StatusProgressList>
        </StatusProgressContainer>
    );
}; 